<script>
import { toInteger } from "lodash";
import LoadingLogo from "@js/loader/LoadingLogo.vue";
export default {
  name: "primevue-hermeneus-preview",
  components: { LoadingLogo },
  methods: { toInteger,
    togglePopover(event) {
      this.popover.toggle(event)
    }
   },
  data() {
    return {
      toggleswitch: true,
      inputnumber: 6,
      checkbox: true,
      inputtext: "Hallo",
      inputslider: [5, 13],
      select_selected: "2",
      select_selected2: "1",
      selectoptions: [
        { "name": "null", "value": "0" },
        { "name": "eins", "value": "1" },
        { "name": "zwei", "value": "2" },
        { "name": "drei", "value": "3" },
      ],
      datepicker_date: null,
      radio_button_selection: "nix",
      popover: null,
      textarea: "hallo",
    };
  },
  mounted() {
    this.popover = this.$refs.popover
  }
}
</script>

<template>
  Hier werden alle PrimeVue-Komponenten angezeigt, die bereits an das Hermeneus-Theme angepasst wurden. Bitte hier
  weitere Komponenten alphabetisch hinzufügen und mit Dokumentation versehen.
  <br>
  <br>
  <br>
  <div class="px-8">
    <h2 id="Button">Button</h2>
    <div class="component-description">
      Verschiedene Button-Varianten mit Icons, Größen und Severity-Levels.
      <br>
      <a href="https://primevue.org/button" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>
      &lt;Button severity="primary" icon="fas fa-trash" label="Primary"&gt;&lt;/Button&gt;
      &lt;Button severity="secondary" label="Secondary" icon="bx bxs-cloud-upload"&gt;&lt;/Button&gt;
      &lt;Button severity="contrast" label="Contrast" icon="bx bxs-cloud-upload"&gt;&lt;/Button&gt;
      &lt;Button severity="blue" label="Blue"&gt;&lt;/Button&gt;
      &lt;Button label="Speichern" outlined severity="secondary" icon="bx bxs-cloud-upload"&gt;&lt;/Button&gt;
      &lt;Button label="Danger" outlined severity="danger" icon="bx bxs-cloud-upload"&gt;&lt;/Button&gt;
      &lt;Button label="Klein" outlined severity="secondary" size="small" icon="bx bxs-cloud-upload"&gt;&lt;/Button&gt;
      &lt;Button label="Groß" outlined severity="secondary" size="large" icon="bx bxs-cloud-upload"&gt;&lt;/Button&gt;
      &lt;Button label="ExtraGroß" outlined severity="secondary" size="xl" icon="bx bxs-cloud-upload"&gt;&lt;/Button&gt;
      &lt;Button label="Disabled" disabled severity="secondary" icon="bx bxs-cloud-upload"&gt;&lt;/Button&gt;
    </code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <div class="flex flex-row justify-evenly items-start">
        <Button severity="primary" icon="fas fa-trash" label="Primary"></Button>
        <Button severity="primary_color" icon="fas fa-trash" label="Primary_Color"></Button>
        <Button severity="secondary" label="Secondary" icon="bx bxs-cloud-upload"></Button>
        <Button severity="contrast" label="Contrast" icon="bx bxs-cloud-upload"></Button>
        <Button severity="blue" label="Blue"></Button>
        <Button label="Speichern" outlined severity="secondary" icon="bx bxs-cloud-upload"></Button>
        <Button label="Danger" outlined severity="danger" icon="bx bxs-cloud-upload"></Button>
        <Button label="Klein" outlined severity="secondary" size="small" icon="bx bxs-cloud-upload"></Button>
        <Button label="Groß" outlined severity="secondary" size="large" icon="bx bxs-cloud-upload"></Button>
        <Button label="Disabled" disabled severity="secondary" icon="bx bxs-cloud-upload"></Button>

      </div>
    </div>

    <h2 id="Checkbox">Checkbox</h2>
    <div class="component-description">
      Binäre Checkbox für Ja/Nein-Auswahl.
      <br>
      <a href="https://primevue.org/checkbox" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;Checkbox v-model="checkbox" binary&gt;&lt;/Checkbox&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Checkbox v-model="checkbox" binary></Checkbox>
    </div>

    <h2 id="Datepicker">Datepicker</h2>
    <div class="component-description">
      Datumsauswahl mit optionaler Zeitauswahl im 24h-Format.
      <br>
      <a href="https://primevue.org/calendar" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;Datepicker 
    dateFormat="dd.mm.yy' um '" 
    v-model="datepicker_date" 
    showTime 
    hourFormat="24" 
    show-icon 
/&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Datepicker id="datepicker-24h" dateFormat="dd.mm.yy' um '" v-model="datepicker_date" showTime hourFormat="24"
        show-icon />
    </div>

    <h2 id="Divider">Divider</h2>
    <div class="component-description">
      Eine horizontale Trennlinie zur visuellen Trennung von Inhalten.
      <br>
      <a href="https://primevue.org/divider" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;Divider&gt;&lt;/Divider&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Divider></Divider>
    </div>

    <h2 id="InputNumber">InputNumber</h2>
    <div class="component-description">
      Numerische Eingabe mit Plus/Minus-Buttons und Wertebegrenzung.
      <br>
      <a href="https://primevue.org/inputnumber" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;InputNumber 
    showButtons 
    buttonLayout="horizontal" 
    :step="1" 
    v-model="inputnumber" 
    :min="5" 
    :max="13"&gt;
&lt;/InputNumber&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <div class="flex flex-row justify-evenly items-start">
        <InputNumber showButtons buttonLayout="horizontal" :step="1" v-model="inputnumber" :min="5" :max="13">
          <template #incrementbuttonicon>
            <span class="fas fa-plus" />
          </template>
          <template #decrementbuttonicon>
            <span class="fas fa-minus" />
          </template>
        </InputNumber>

        <InputNumber showButtons :step="1" v-model="inputnumber" class="ml-5" fluid :min="5" :max="13">
          <template #incrementbuttonicon>
            <span class="fas fa-angle-up" />
          </template>
          <template #decrementbuttonicon>
            <span class="fas fa-angle-down" />
          </template>
        </InputNumber>
      </div>
    </div>

    <h2 id="InputText">InputText</h2>
    <div class="component-description">
      Eingabefeld mit optionaler Fehlermeldung.
      <br>
      <a href="https://primevue.org/inputtext" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;InputText
    v-model="inputtext"
    :class="{'p-invalid': !inputtext}"
    aria-describedby="inputtext-error"
    placeholder="Bitte eingeben"&gt;
    &lt;/InputText&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <InputText v-model="inputtext" :class="{ 'p-invalid': !inputtext }" aria-describedby="inputtext-error"
        placeholder="Bitte eingeben"></InputText>
    </div>





    <h2 id="Loader">Loader</h2>
    <div class="component-description">
      Animiertes Hermeneus-Logo als Ladeindikator. Akzeptiert eine <code>size</code>-Prop (Pixelwert, Standard: 80).
    </div>

    <h3>Code</h3>
    <pre><code>&lt;loading-logo&gt;&lt;/loading-logo&gt;
&lt;loading-logo :size="40"&gt;&lt;/loading-logo&gt;
&lt;loading-logo :size="120"&gt;&lt;/loading-logo&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <div class="flex flex-row items-center gap-10">
        <div class="flex flex-col items-center gap-2">
          <loading-logo :size="40"></loading-logo>
          <span class="text-xs text-grey-500">size: 40</span>
        </div>
        <div class="flex flex-col items-center gap-2">
          <loading-logo></loading-logo>
          <span class="text-xs text-grey-500">size: 80 (Standard)</span>
        </div>
        <div class="flex flex-col items-center gap-2">
          <loading-logo :size="120"></loading-logo>
          <span class="text-xs text-grey-500">size: 120</span>
        </div>
      </div>
    </div>

    <h2 id="Paginator">Paginator</h2>
    <div class="component-description">
      Navigationselement für mehrseitige Inhalte mit First/Prev/Next/Last Buttons.
      <br>
      <a href="https://primevue.org/paginator" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;Paginator
    :totalRecords="20"
    :rows="2"
    :pageLink-size="5"
    template="FirstPageLink PrevPageLink NextPageLink LastPageLink"
    currentPageReportTemplate="Ergebnisse {first} bis {last} von {totalRecords}"
    &gt;&lt;/Paginator&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Paginator :totalRecords="20" :rows="2" :page-link-size="5" :pt="{ root: '!justify-end !px-0' }"
        template="FirstPageLink PrevPageLink NextPageLink LastPageLink"
        currentPageReportTemplate="Ergebnisse {first} bis {last} von {totalRecords}"></Paginator>
    </div>

    <h2 id="Popover">Popover</h2>
    <div class="component-description">
      Popover als Componente.
      <br>
      <a href="https://primevue.org/popover" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>

    <pre>
      // Im Script:
      // ...
      methods: {
        togglePopover() {
          this.$refs.popover.toggle()
        }
      },
      data() {
        return {
          popover: null
        }
      },
      mounted() {
        this.popover = this.$refs.popover
      }
    // ... 
    
    // Im Template: 
    <code>&lt;Button icon="fas fa-mouse" @click="togglePopover" label="Klick"&gt;&lt;/Button&gt;
    &lt;Popover ref="popover"&gt;
        pöksiodjföoisddfnhosdfsbngiosdfbgs
    &lt;/Popover&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Button icon="fas fa-mouse" @click="togglePopover" label="Klick"></Button>
      <Popover ref="popover">
        pöksiodjföoisddfnhosdfsbngiosdfbgs
      </Popover>
    </div>

    <h2 id="ProgressBar">ProgressBar</h2>
    <div class="component-description">
      Fortschrittsanzeige im unbestimmten Modus.
      <br>
      <a href="https://primevue.org/progressbar" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;ProgressBar mode="indeterminate"&gt;&lt;/ProgressBar&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <ProgressBar mode="indeterminate"></ProgressBar>
    </div>

    <h2 id="RadioButton">RadioButton</h2>
    <div class="component-description">
      Radiobuttons mit verschiedenen Farbvarianten (primary/secondary).
      <br>
      <a href="https://primevue.org/radiobutton" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;RadioButton
    v-model="radio_button_selection"
    inputId="ingredient1"
    name="nix"
    value="nix"
    variant="primary"
    /&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <div class="flex flex-wrap gap-3">
        <div class="flex items-center">
          <RadioButton v-model="radio_button_selection" inputId="ingredient1" name="nix" value="nix" />
          <label for="ingredient1" class="ml-2">Nix</label>
        </div>
        <div class="flex items-center">
          <RadioButton v-model="radio_button_selection" inputId="ingredient2" name="Hoho" value="hoho"
            variant="secondary" />
          <label for="ingredient2" class="ml-2">Hoho</label>
        </div>
        <div class="flex items-center">
          <RadioButton v-model="radio_button_selection" inputId="ingredient3" name="Hoho" value="hihi"
            variant="primary" />
          <label for="ingredient3" class="ml-2">Hihi</label>
        </div>
      </div>
    </div>

    <h2 id="Select">Select</h2>
    <div class="component-description">
      Dropdown-Auswahlfeld mit konfigurierbaren Optionen.
      <br>
      <a href="https://primevue.org/select" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;Select
    v-model="select_selected"
    option-label="name"
    option-value="value"
    :options="selectoptions"
    placeholder="Bitte auswählen"&gt;
    &lt;/Select&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <div class="flex flex-row justify-between">
        <Select v-model="select_selected" option-label="name" option-value="value" :options="selectoptions"
          placeholder="Bitte auswählen"></Select>
        Inline-Options:
        <Select v-model="select_selected2" option-label="name" option-value="value" :options='[
          { "name": "null", "value": "0" },
          { "name": "eins", "value": "1" },
          { "name": "zwei", "value": "2" },
          { "name": "drei", "value": "3" }
        ]' placeholder="Bitte auswählen">
        </Select>
      </div>
    </div>

    <h2 id="Slider">Slider</h2>
    <div class="component-description">
      Slider mit optionaler Anzeige der aktuellen Wert.
      <br>
      <a href="https://primevue.org/slider" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;Slider v-model="inputslider" :min="5" :max="13" :step="1" show-value range&gt;&lt;/Slider&gt;</code>
</pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Slider v-model="inputslider" range :min="5" :max="13" :step="1" show-value></Slider>
    </div>



    <h2 id="Stepper">Stepper</h2>
    <div class="component-description">
      Stepper mit optionaler Anzeige der aktuellen Schritte.
      <br>
      <a href="https://primevue.org/stepper" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Stepper value="1" class="basis-[50rem]">
        <StepList>
          <Step value="1">Header I</Step>
          <Step value="2">Header II</Step>
          <Step value="3">Header III</Step>
        </StepList>
        <StepPanels>
          <StepPanel v-slot="{ activateCallback }" value="1">
            <div class="flex flex-col h-48">
              <div
                class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex-auto flex justify-center items-center font-medium">
                Content I</div>
            </div>
            <div class="flex pt-6 justify-end">
              <Button label="Next" icon="pi pi-arrow-right" iconPos="right" @click="activateCallback('2')" />
            </div>
          </StepPanel>
          <StepPanel v-slot="{ activateCallback }" value="2">
            <div class="flex flex-col h-48">
              <div
                class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex-auto flex justify-center items-center font-medium">
                Content II</div>
            </div>
            <div class="flex pt-6 justify-between">
              <Button label="Back" severity="secondary" icon="pi pi-arrow-left" @click="activateCallback('1')" />
              <Button label="Next" icon="pi pi-arrow-right" iconPos="right" @click="activateCallback('3')" />
            </div>
          </StepPanel>
          <StepPanel v-slot="{ activateCallback }" value="3">
            <div class="flex flex-col h-48">
              <div
                class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50 dark:bg-surface-950 flex-auto flex justify-center items-center font-medium">
                Content III</div>
            </div>
            <div class="pt-6">
              <Button label="Back" severity="secondary" icon="pi pi-arrow-left" @click="activateCallback('2')" />
            </div>
          </StepPanel>
        </StepPanels>
      </Stepper>
    </div>
    <h3>Code</h3>
    <pre><code>&lt;Stepper value="1" class="basis-[50rem]"&gt;
    &lt;StepList&gt;
    &lt;Step value="1"&gt;Header I&lt;/Step&gt;
    &lt;Step value="2"&gt;Header II&lt;/Step&gt;
    &lt;Step value="3"&gt;Header III&lt;/Step&gt;
    &lt;/StepList&gt;
    &lt;StepPanels&gt;
    &lt;StepPanel v-slot="{ activateCallback }" value="1"&gt;
    &lt;div class="flex flex-col h-48"&gt;
    &lt;div class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50
    dark:bg-surface-950 flex-auto flex justify-center items-center font-medium"&gt;Content I&lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="flex pt-6 justify-end"&gt;
    &lt;Button label="Next" icon="pi pi-arrow-right" iconPos="right" @click="activateCallback('2')" /&gt;
    &lt;/div&gt;
    &lt;/StepPanel&gt;
    &lt;StepPanel v-slot="{ activateCallback }" value="2"&gt;
    &lt;div class="flex flex-col h-48"&gt;
    &lt;div class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50
    dark:bg-surface-950 flex-auto flex justify-center items-center font-medium"&gt;Content II&lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="flex pt-6 justify-between"&gt;
    &lt;Button label="Back" severity="secondary" icon="pi pi-arrow-left" @click="activateCallback('1')" /&gt;
    &lt;Button label="Next" icon="pi pi-arrow-right" iconPos="right" @click="activateCallback('3')" /&gt;
    &lt;/div&gt;
    &lt;/StepPanel&gt;
    &lt;StepPanel v-slot="{ activateCallback }" value="3"&gt;
    &lt;div class="flex flex-col h-48"&gt;
    &lt;div class="border-2 border-dashed border-surface-200 dark:border-surface-700 rounded bg-surface-50
    dark:bg-surface-950 flex-auto flex justify-center items-center font-medium"&gt;Content III&lt;/div&gt;
    &lt;/div&gt;
    &lt;div class="pt-6"&gt;
    &lt;Button label="Back" severity="secondary" icon="pi pi-arrow-left" @click="activateCallback('2')" /&gt;
    &lt;/div&gt;
    &lt;/StepPanel&gt;
    &lt;/StepPanels&gt;
    &lt;/Stepper&gt;</code></pre>

    <h2 id="Textarea">Textarea</h2>
    <div class="component-description">
      Mehrzeiliger Eingabefeld.
      <br>
      <a href="https://primevue.org/textarea" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;Textarea v-model="textarea" :autoResize="true" rows="5" cols="30"&gt;&lt;/Textarea&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Textarea v-model="textarea" :autoResize="true" rows="5" cols="30"></Textarea>
    </div>

    <h2 id="Toggleswitch">Toggleswitch</h2>
    <div class="component-description">
      Ein/Aus-Schalter für boolesche Werte.
      <br>
      <a href="https://primevue.org/toggleswitch" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;ToggleSwitch v-model="toggleswitch"&gt;&lt;/ToggleSwitch&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <ToggleSwitch v-model="toggleswitch"></ToggleSwitch>
    </div>


    <h2 id="Tooltip">Tooltip</h2>
    <div class="component-description">
      Tooltip als vue-Directive.
      <br>
      <a href="https://primevue.org/tooltip" target="_blank">PrimeVue Dokumentation</a>
    </div>

    <h3>Code</h3>
    <pre><code>&lt;Button v-tooltip="{ value: 'Yeah, ein Tooltip!', showDelay: 500, hideDelay: 300 }" label="Hover me!"&gt;&lt;/Button&gt;</code></pre>

    <h3>Beispiel</h3>
    <div class="example-section">
      <Button v-tooltip="{ value: 'Yeah, ein Tooltip!', showDelay: 500, hideDelay: 300 }" label="Hover me!" />
  </div>
  </div>
</template>

<style scoped>
h2 {
  margin-top: 3rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
  font-size: 1.5rem;
}

h3 {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  font-size: 1.1rem;
}

.component-description {
  margin-bottom: 1rem;
}

pre {
  margin: 0rem 0 1rem 0;
  padding: 1rem;
  background-color: #383d59;
  color: #fff;
  border-radius: 0.5rem;
}

.example-section {
  background-color: #fff;
  padding: 2rem;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
}
</style>